import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { PagedRawImageDetailModel } from 'src/app/chief-editor/models/paged.raw.image.detail.model';
import { RawImageService } from 'src/app/chief-editor/services/raw.image.service';
import { AppUtils } from 'src/app/helpers/app.utils';
import { TableModel } from 'src/app/models/table.model';

@Component({
    selector: 'app-raw-image-manage-grouped',
    templateUrl: './raw.image.manage.component.html',
    styleUrls: ['./raw.image.manage.component.scss']
})
export class RawImageManageComponent implements OnInit {

    unixTimeStamp: number;
    contributorId: string;
    tableModel: TableModel;
    totalRecords: number;
    selectedAll = false;
    showActionButtons = false;
    private subscriptions: Subscription[];
    pagedRawImageDetail = new PagedRawImageDetailModel();

    constructor(private router: Router,
        private route: ActivatedRoute,
        private ngxSpinner: NgxSpinnerService,
        private toastr: ToastrService,
        private rawImageService: RawImageService) {
        this.route.queryParams.subscribe(params => {
            this.unixTimeStamp = params['unixTimeStamp'];
            this.contributorId = params['contributerId'];
        });
    }
    ngOnInit(): void {
        this.tableModel = new TableModel();
        this.totalRecords = 0;
        this.subscriptions = [];
        this.initSubscribers();
        this.getRawImages();
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getRawImages());
        this.subscriptions.push(subscription);
    }

    selectAll() {
        this.pagedRawImageDetail.items.forEach(element => {
            if (element.status === 3) {
                element.isSelected = this.selectedAll;
                this.showActionButtons = this.selectedAll;
            }
        });
    }

    updateSelectAll() {
        const selectedImageList = this.pagedRawImageDetail.items.filter(x => x.isSelected);
        if (selectedImageList.length !== this.pagedRawImageDetail.items.length) {
            this.selectedAll = false;
        } else {
            this.selectedAll = true;
        }
        if (selectedImageList.length !== 0) {
            this.showActionButtons = true;
        } else {
            this.showActionButtons = false;
        }
    }

    getRawImages() {
        this.ngxSpinner.show();
        this.rawImageService.getList(this.unixTimeStamp, this.contributorId, this.tableModel).subscribe(
            res => {
                this.pagedRawImageDetail = res;
                this.totalRecords = this.pagedRawImageDetail.totalCount;
                this.selectedAll = false;
                this.ngxSpinner.hide();
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    markAsUnprocessed() {
        const rawImageIds = new Array<string>();
        this.pagedRawImageDetail.items.forEach(element => {
            if (element.isSelected) {
                rawImageIds.push(element.id);
            }
        });

        if (rawImageIds.length === 0) {
            return;
        }

        if (!confirm('Are you sure you want to mark these images as unprocessed?')) {
            return;
        }

        this.ngxSpinner.show();
        this.rawImageService.markAsUnprocessed(rawImageIds).subscribe(
            () => {
                this.ngxSpinner.hide();
                this.getRawImages();
                this.selectedAll = false;
                this.showActionButtons = false;
                this.toastr.success('Images have been unprocessed successfully.');
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    sendSelectedImagesForApproval() {
        const rawImageIds = new Array<string>();
        this.pagedRawImageDetail.items.forEach(element => {
            if (element.isSelected) {
                rawImageIds.push(element.id);
            }
        });

        if (rawImageIds.length === 0) {
            return;
        }

        if (!confirm('Are you sure you want to send these images for approval?')) {
            return;
        }
        this.ngxSpinner.show();
        this.rawImageService.sendSelectedImagesForApproval(rawImageIds).subscribe(() => {
            this.ngxSpinner.hide();
            this.getRawImages();
            this.selectedAll = false;
            this.showActionButtons = false;
            this.toastr.success('Images have been successfully sent for approval.');
        }, error => {
            this.ngxSpinner.hide();
            AppUtils.processErrorResponse(this.toastr, error);
        });
    }
}
